import { dbPut, normalizeCard, normalizeDeck } from '../core/db.js';
import { scopedCards, visCourses } from '../core/load.js';
import { state } from '../core/state.js';
import { $, esc, uid } from '../core/text.js';
import { cardsAsPayload } from '../social/api.js';
import { modal } from '../ui/modal.js';
import { toast } from '../ui/toast.js';
import { cardManagerModal } from '../views/dashboard.js';

/* ══════════ Import aus anderen Apps (Anki / Quizlet / CSV) ══════════ */
export function parseSmart(text, opt = {}) {
  const rowSep = opt.rowSep || 'nl';
  const lines = rowSep === 'semicolon' ? text.split(/;+/) : text.split(/\r?\n/);
  const out = [];
  for (const raw of lines) {
    let line = raw.replace(/﻿/g, '').trim();
    if (!line || line.startsWith('#')) continue;               // Anki-Kommentarzeilen (#separator etc.)
    let parts;
    if (opt.sep === 'tab') parts = line.split('\t');
    else if (opt.sep === 'comma') parts = splitCSV(line);
    else if (opt.sep === 'dash') parts = line.split(/\s[–-]\s/);
    else {                                                      // auto
      if (line.includes('\t')) parts = line.split('\t');
      else if (/\s[–-]\s/.test(line)) parts = line.split(/\s[–-]\s/);
      else if (line.includes(';')) parts = line.split(';');
      else parts = splitCSV(line);
    }
    const q = (parts[0] || '').trim();
    const a = (parts.slice(1).join(opt.sep === 'comma' ? ', ' : ' ').trim()) || (parts[1] || '').trim();
    if (q && a) out.push({ q: stripHTML(q), a: stripHTML(a) });
  }
  // führende Kopfzeile (Frage,Antwort / Term,Definition …) überspringen
  const HEAD = new Set(['frage', 'antwort', 'front', 'back', 'term', 'definition', 'question', 'answer', 'vorderseite', 'rückseite', 'ruckseite']);
  if (out.length > 1 && HEAD.has(out[0].q.toLowerCase()) && HEAD.has(out[0].a.toLowerCase())) out.shift();
  return out;
}
export function splitCSV(line) {
  const out = []; let cur = '', inQ = false;
  for (let i = 0; i < line.length; i++) {
    const ch = line[i];
    if (ch === '"') { if (inQ && line[i + 1] === '"') { cur += '"'; i++; } else inQ = !inQ; }
    else if ((ch === ',' || ch === '\t') && !inQ) { out.push(cur); cur = ''; }
    else cur += ch;
  }
  out.push(cur);
  return out.map((s) => s.trim());
}
export const stripHTML = (s) => s.replace(/<br\s*\/?>/gi, ' ').replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').trim();

export function smartImportModal() {
  const courses = visCourses();
  const courseOpts = courses.map((c) => `<option value="${c.id}">${esc(c.emoji || '📚')} ${esc(c.name)}</option>`).join('');
  modal({
    title: '⬆ Karten importieren', okText: 'Importieren',
    body: `<p class="page-sub">Füge Karten aus <b>Anki</b> (Notizen als Text exportieren), <b>Quizlet</b> (Exportieren → Kopieren) oder einer CSV/TSV-Datei ein. Format wird automatisch erkannt.</p>
           <div class="field"><label>Ziel</label>
             <select class="select" id="si-target">
               <option value="__new">➕ Neuer Kurs aus diesen Karten</option>
               ${courseOpts}
             </select></div>
           <div class="field" id="si-newname-wrap"><label>Name des neuen Kurses</label><input class="input" id="si-newname" placeholder="Importierte Karten"></div>
           <div class="field"><label>Trennzeichen</label>
             <select class="select" id="si-sep">
               <option value="auto">Automatisch erkennen</option>
               <option value="tab">Tabulator (Anki)</option>
               <option value="comma">Komma / CSV (Quizlet)</option>
               <option value="dash">Gedankenstrich –</option>
             </select></div>
           <div class="field"><label>Karten (Vorderseite&nbsp;·&nbsp;Rückseite je Zeile)</label>
             <textarea class="textarea" id="si-text" rows="8" placeholder="Zelle&#9;Grundbaustein des Lebens&#10;Photosynthese&#9;Umwandlung von Licht in Energie"></textarea></div>
           <div class="row-actions"><button class="btn-ghost outline tiny" id="si-file">Aus Datei laden…</button>
             <span class="status" id="si-count" style="margin:0"></span></div>`,
    onOk: async () => {
      const sep = $('#si-sep').value;
      const pairs = parseSmart($('#si-text').value, { sep });
      if (!pairs.length) { toast('Keine gültigen Karten erkannt'); return false; }
      let courseId, deckId;
      const target = $('#si-target').value;
      if (target === '__new') {
        const nm = $('#si-newname').value.trim() || 'Importierte Karten';
        const course = { id: uid(), name: nm, emoji: '📥', created: Date.now(), archived: false };
        await dbPut('courses', course); state.courses.push(course); courseId = course.id;
        state.selCourse = course.id; state.openCourses.add(course.id);
      } else {
        courseId = target;
      }
      let dk = state.decks.find((d) => d.courseId === courseId);
      if (!dk) { dk = normalizeDeck({ id: uid(), courseId, name: 'Importiert', created: Date.now() }); await dbPut('decks', dk); state.decks.push(dk); }
      deckId = dk.id;
      for (const pr of pairs) {
        const rec = normalizeCard({ id: uid(), courseId, deckId, front: { text: pr.q, image: null }, back: { text: pr.a, image: null }, created: Date.now() });
        await dbPut('cards', rec); state.cards.push(rec);
      }
      $('#ie-status') && ($('#ie-status').textContent = `${pairs.length} Karten importiert.`);
      toast(`${pairs.length} Karten importiert ✦`); state.coll = null; cardManagerModal();
    },
  });
  const upd = () => { const n = parseSmart($('#si-text').value, { sep: $('#si-sep').value }).length; $('#si-count').textContent = n ? `${n} Karten erkannt` : ''; };
  setTimeout(() => {
    const tgt = $('#si-target'), wrap = $('#si-newname-wrap');
    const syncTgt = () => { wrap.style.display = tgt.value === '__new' ? '' : 'none'; };
    tgt.onchange = syncTgt; syncTgt();
    $('#si-text').oninput = upd; $('#si-sep').onchange = upd;
    $('#si-file').onclick = () => {
      const inp = document.createElement('input'); inp.type = 'file'; inp.accept = '.csv,.tsv,.txt,text/csv,text/plain';
      inp.onchange = () => { const f = inp.files[0]; if (!f) return; const r = new FileReader(); r.onload = () => { $('#si-text').value = r.result; upd(); }; r.readAsText(f); };
      inp.click();
    };
  }, 60);
}

/* ── Export der Auswahl als CSV bzw. Anki-Text (Tab-getrennt) ── */
export function exportCardsAs(kind) {
  const cards = state.selCourse ? scopedCards() : state.cards;
  if (!cards.length) { const s = $('#ie-status'); if (s) { s.textContent = 'Erst einen Kurs/Vorlesung auswählen (oder Karten anlegen).'; s.className = 'status err'; } return; }
  const rows = cardsAsPayload(cards);
  let content, ext, mime;
  if (kind === 'anki') {
    content = rows.map((c) => [c.front, c.back].map((x) => x.replace(/\t/g, ' ')).join('\t')).join('\n');
    ext = 'txt'; mime = 'text/plain';
  } else {
    const q = (s) => '"' + String(s).replace(/"/g, '""') + '"';
    content = 'Frage,Antwort\n' + rows.map((c) => q(c.front) + ',' + q(c.back)).join('\n');
    ext = 'csv'; mime = 'text/csv';
  }
  const base = state.selCourse ? (state.courses.find((c) => c.id === state.selCourse)?.name || 'karten') : 'alle-karten';
  const name = base.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') + '.' + ext;
  const blob = new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob); const a = document.createElement('a'); a.href = url; a.download = name; a.click(); URL.revokeObjectURL(url);
  const s = $('#ie-status'); if (s) { s.textContent = `${rows.length} Karten als ${ext.toUpperCase()} exportiert.`; s.className = 'status ok'; }
  toast(`${rows.length} Karten exportiert ✦`);
}

